import { BlankV2ReadOnlyPlugin } from '../plugins-common/BlankV2/BlankV2ReadOnlyPlugin';
import { CorrectAnswersReadOnlyPlugin } from '../plugins-common/CorrectAnswers/CorrectAnswersReadOnlyPlugin';
import { ExerciseMultipleChoiceReadOnlyPlugin } from '../plugins/ExerciseMultipleChoice/ExerciseMultipleChoiceReadOnlyPlugin';
import { ExerciseGapFillReadOnlyPlugin } from '../plugins/GapFill/ExerciseGapFillReadOnlyPlugin';
import { ExerciseShortAnswerReadOnlyPlugin } from '../plugins/ExerciseShortAnswer/ExerciseShortAnswerReadOnlyPlugin';
import { ExplanationsReadOnlyPlugin } from '../plugins-common/Explanations/ExplanationsReadOnlyPlugin';
import { ImageToggleReadOnlyPlugin } from '../plugins-common/ImageToggle/ImageToggleReadOnlyPlugin';
import { ParagraphToggleReadOnlyPlugin } from '../plugins-common/ParagraphToggle/ParagraphToggleReadOnlyPlugin';
import { QuestionStarterReadOnlyPlugin } from '../plugins-common/QuestionStarter/QuestionStarterReadOnlyPlugin';
import { ExerciseGapFillWithHintReadOnlyPlugin } from '../plugins/ExerciseGapFillWithHint/ExerciseGapFillWithHintReadOnlyPlugin';
import { FaqReadOnlyPlugin } from '../plugins/FAQ/FaqReadOnlyPlugin';
import { ExerciseQuizReadOnlyPlugin } from '../plugins/ExerciseQuiz/ExerciseQuizReadOnlyPlugin';

export const getAllExerciseReadOnlyPlugins = ({ isReadOnly = true, onBackWhenInComplete }) => [
  BlankV2ReadOnlyPlugin({ isReadOnly }),
  CorrectAnswersReadOnlyPlugin({ isReadOnly }),
  ExerciseMultipleChoiceReadOnlyPlugin({ isReadOnly, onBackWhenInComplete }),
  ExerciseGapFillReadOnlyPlugin({ isReadOnly, onBackWhenInComplete }),
  ExerciseShortAnswerReadOnlyPlugin({ isReadOnly, onBackWhenInComplete }),
  ExplanationsReadOnlyPlugin({ isReadOnly }),
  ImageToggleReadOnlyPlugin({ isReadOnly }),
  ParagraphToggleReadOnlyPlugin({ isReadOnly }),
  QuestionStarterReadOnlyPlugin({ isReadOnly }),
  ExerciseGapFillWithHintReadOnlyPlugin({ isReadOnly, onBackWhenInComplete }),
  FaqReadOnlyPlugin({ isReadOnly }),
  ExerciseQuizReadOnlyPlugin({ isReadOnly }),
];
